const elementMatchesSelector = (element, selector) => {
  try {
    return element.matches(selector);
  } catch (e) {
    console.error(e);
  }

  return false;
};

export default elementMatchesSelector;
